/**
 * Dashboard Header Component
 */
import React from 'react';

interface DashboardHeaderProps {
  onLogout: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ onLogout }) => (
  <div className="flex justify-between items-center mb-4">
    <h1 className="text-xl font-bold text-gray-800">Espace Utilisateur</h1>
    <button 
      onClick={onLogout} 
      className="text-red-500 text-sm hover:underline"
    >
      Deconnexion
    </button>
  </div>
);

export default DashboardHeader;
